export default __webpack_public_path__ + "static/media/grapefruit-carousel-headline-box@3x.dffb9788.png";